import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Modal from "@/components/modal/Modal";
import { literals } from "@/constants/literals";

interface ConfirmContinueGarageModalProps {
  continueCapture: (
    event: React.BaseSyntheticEvent<
      Event,
      EventTarget & HTMLFormElement,
      EventTarget
    >,
  ) => void;
  closeModal: () => void;
  messageToShow: string;
}

const ConfirmContinueGarageModal = ({
  continueCapture,
  closeModal,
  messageToShow,
}: ConfirmContinueGarageModalProps) => {
  return (
    <Modal
      title={literals.existingOrder}
      opened={messageToShow !== ""}
      onClose={closeModal}
    >
      <p className="mb-8 text-ib-pt-main text-ib-pt-color-gray-1000">
        {`${messageToShow} ${literals.wantContinueClic}`}
      </p>
      <div className="mb-4">
        <PrimaryButton
          colour="red"
          label={literals.continue}
          onClick={continueCapture}
          size="medium"
        />
      </div>
      <div>
        <SecondaryButton
          colour="red"
          label={literals.cancel}
          onClick={closeModal}
          size="medium"
        />
      </div>
    </Modal>
  );
};

export default ConfirmContinueGarageModal;
